import { action, computed, makeObservable, observable } from 'mobx';

import {
  CellControllerKind,
  TextControllerEntity,
} from 'entities/TableControllers';

import { ITableControllerBase } from '../interface';

type PrivateFields = '_value';

export default class TableTextControllerStore
  implements ITableControllerBase<TextControllerEntity['controller']['value']>
{
  constructor(record: TextControllerEntity) {
    this._value = record.controller;
    makeObservable<TableTextControllerStore, PrivateFields>(this, {
      _value: observable.ref,
      controllerValue: computed,

      toServerFormat: computed,

      destroy: action.bound,
    });
  }

  private _value: TextControllerEntity['controller'];

  readonly isUpdateBlocked = false;

  get controllerKind() {
    return CellControllerKind.TEXT;
  }

  get controllerValue(): string {
    return this._value.value || '';
  }

  get toServerFormat() {
    return this._value.value;
  }

  destroy(): void {
    // do nothing
  }

  setValue(newValue: string): void {
    this._value = {
      ...this._value,
      value: newValue,
    };
  }
}
